


export const formatInputToMMDDYYYY = (input: string) => {
  const [yyyy, mm, dd] = input.split("-");
  // return `${mm}/${dd}/${yyyy}`;
    return `${dd}-${mm}-${yyyy}`;
};


export const subtractDays = (date: Date, days: number): Date => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() - days);
  return newDate;
};

export const formatDateForInput = (date: Date): string => {
  // Format as YYYY-MM-DD for input[type="date"]
  return date.toISOString().split("T")[0];
};

export const formatDateToMMDDYYYY = (date: Date): string => {
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};